<template>
  <div class="recharge-details">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">{{ hasAudited ? '充值详情' : '申请充值审核' }}</div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="80px">
        <el-form-item v-if="['CHARGE_OFFLINE_ACCT', 'CHARGE_OTHER', 'CHARGE_QRCODE'].includes(basicInfo.tradeMethod)" label="流水号:">{{ basicInfo.serialNo }}</el-form-item>
        <el-form-item label="创建日期:" v-if="['CHARGE_OFFLINE_BONUS', 'CHARGE_OFFLINE_SETTLE'].includes(basicInfo.tradeMethod)">{{ basicInfo.dateCreated }}</el-form-item>
        <el-form-item :label="basicInfo.tradeMethod === 'CHARGE_OFFLINE_ACCT' ? '付款日期:' : '支付日期:'" v-if="['CHARGE_QRCODE', 'CHARGE_OFFLINE_ACCT'].includes(basicInfo.tradeMethod)">{{
          basicInfo.tradeMethod === 'CHARGE_OFFLINE_ACCT' ? basicInfo.bankTradeDate : basicInfo.paymentDate }}</el-form-item>
        <el-form-item label="平台号:">{{ basicInfo.store.code }}</el-form-item>
        <el-form-item label="平台名称:">{{ basicInfo.store.name }}</el-form-item>
        <el-form-item label="金额:">{{ basicInfo.amount }}</el-form-item>
        <!-- <el-form-item label="充值金额:" v-if="hasAudited">{{ basicInfo.amount }}</el-form-item> -->
        <!-- <el-form-item label="充值金额:" v-else>
          <el-input v-model="inputAmount"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="虚拟充值:">{{ basicInfo.bonus }}</el-form-item> -->
        <el-form-item label="充值方式:">{{ $config.vpayChargeMethod[basicInfo.tradeMethod] || basicInfo.tradeMethod }}</el-form-item>
        <div style="display: flex" v-if="['CHARGE_OFFLINE_ACCT', 'CHARGE_OTHER'].includes(basicInfo.tradeMethod)">
          <el-form-item label="收款账户:" style="margin-right: 100px;">{{ getBankAccount.bankName }}</el-form-item>
          <el-form-item label="账户号:">{{ getBankAccount.cardNo }}</el-form-item>
        </div>
        <el-form-item label="支付凭证:" v-if="['CHARGE_OFFLINE_ACCT', 'CHARGE_OTHER'].includes(basicInfo.tradeMethod)" style="align-items: initial">
          <div>
            <img :src="basicInfo.voucher" alt="" class="img">
          </div>
        </el-form-item>
        <el-form-item label="备注:">{{ basicInfo.remark }}</el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round v-show="!hasAudited" @click="onReject" :loading="loading" v-if='$hasPermission("epay:admin:charge:modify")'>审核拒绝</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="OffDialog = true, byStoreIds()" v-if="hasAudited && basicInfo.tradeMethod === 'CHARGE_QRCODE' && basicInfo.tradeStatus !== 'APPLY_REFUND' && basicInfo.tradeStatus !== 'PARTIAL_REFUNDED' && basicInfo.paymentStatus
        !== 'UNPAID'">申请退款</el-button>
      <el-button round type="primary" @click="returnPage" :loading="loadingPage" v-if="hasAudited">返回</el-button>
      <el-button round type="primary" @click="returnPage" :loading="loadingPage" v-if="!hasAudited && $hasPermission('epay:admin:charge:modify')">审核通过</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title='原因' :visible.sync='IsReject' width="30%">
      <el-input v-model="remarks" type="textarea" clearable></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsReject = false">取 消</el-button>
        <el-button type="primary" @click="reject">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 线下退款 -->
    <el-dialog :close-on-click-modal="false" title="申请退款" :visible.sync="OffDialog" width="40%" @close="OffDialog = false">
      <el-form :label-position="labelPosition" ref="formNames" label-width="160px" :model="formLabelAlign" :rules="rulesLabelAlign">
        <el-form-item label="当前余额:"> {{ formLabelAlign.ACCT }} </el-form-item>
        <el-form-item label="当前礼金券:"> {{ formLabelAlign.BONUS }} </el-form-item>
        <el-form-item label="充值金额:"> {{ basicInfo.amount }} </el-form-item>
        <el-form-item label="退款金额:" prop="amount">
          <el-input v-model="formLabelAlign.amount" style="width:200px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="清空礼金券额度:" prop="clearQuota">
          <!-- <el-input v-model="formLabelAlign.clearQuota" style="width:200px;" clearable></el-input> --> {{ formLabelAlign.BONUS }} </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="formLabelAlign.remark" type="textarea" :rows="2" placeholder="请输入内容" style="width:200px;" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="OffDialog = false">取 消</el-button>
        <el-button type="primary" @click="setOff()" :loading="offLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { chargeGet, chargeHandle, bankAccountGetAll, addRefund, getByStoreIds } from '@/api/epay'
export default {
  name: 'VpayChargeDetail',
  data () {
    // 校验金额
    var checkAmount = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      const regAmount = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (value === '') {
        callback(new Error('请输入金额'))
      } else if (regAmount.test(value)) {
        return callback()
      } else {
        // callback(new Error('请输入正整数(不包括0)'))
        callback(new Error('请输入正数且小数点后精度两位'))
      }
    }
    var checkClearQuota = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      const regAmount = /^(?!(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (value === '') {
        callback(new Error('请输入金额'))
      } else if (regAmount.test(value)) {
        return callback()
      } else {
        // callback(new Error('请输入正整数(不包括0)'))tana
        callback(new Error('请输入正数且小数点后精度两位'))
      }
    }
    return {
      OffDialog: false,
      formLabelAlign: {
        ACCT: '', // 当前余额
        BONUS: '', // 赠送余额
        amount: '', // 退款金额
        clearQuota: '', // 清空赠送余额
        remark: '', // 备注
        storeId: ''
      },
      rulesLabelAlign: {
        amount: [
          { validator: checkAmount, trigger: 'change' }
        ]
        // clearQuota: [
        //   { validator: checkClearQuota, trigger: 'change' }
        // ]
      },
      submitForm: {
        amount: '',
        bonus: '',
        orderNo: '',
        remark: ''
      },
      IsReject: false,
      remarks: '', // 驳回原因
      offLoading: false,
      loading: false,
      loadingPage: false,
      basicInfo: {
        bankAccountId: '', // 收款账户ID
        paymentDate: '',
        store: {
          code: '',
          name: ''
        },
        bankAccount: {
          bankName: '',
          cardNo: ''
        }
      },
      hasAudited: true,
      inputAmount: null,
      bankList: [] // 收款账户列表
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  async created () {
    await this.getMsg()
    if (this.basicInfo.tradeMethod === 'CHARGE_OFFLINE_ACCT' || this.basicInfo.tradeMethod === 'CHARGE_OTHER') await this.getBankList()
  },
  methods: {
    // 线上退款
    setOff (formNames) {
      if (!this.formLabelAlign.amount) {
        this.$message.error('退款金额不能为空')
        return
      }
      // if (this.formLabelAlign.clearQuota === '') {
      //   this.$message.error('清空赠送额度不能为空')
      //   return
      // }
      this.$refs.formNames.validate((a) => {
        // if (this.formLabelAlign.clearQuota > this.formLabelAlign.BONUS) {
        //   this.tipDialog = true
        //   return
        // }
        if (this.formLabelAlign.amount > this.formLabelAlign.ACCT || this.formLabelAlign.amount > this.basicInfo.amount) {
          this.$message.error('退款金额不能大于当前余额并且不能大于充值金额')
          return
        }
        if (a) {
          let data = {
            amount: this.formLabelAlign.amount,
            remark: this.formLabelAlign.remark,
            bonus: this.formLabelAlign.BONUS,
            storeId: this.basicInfo.storeId,
            accountType: 'ACCT',
            originType: 'WEB',
            tradeMethod: 'REFUND_ONLINE',
            channel: 'B2B',
            serialNo: this.basicInfo?.serialNo
          }
          this.offLoading = true
          addRefund(data).then(res => {
            console.log(res)
            if (res.data.success) {
              this.OffDialog = false
              this.$message.success('申请成功')
              this.offLoading = false
              this.$router.go(-1)
              // this.Empty()
              // this.onSubmit()
            }
          })
        }
      })
    },
    // 获取账户余额
    byStoreIds () {
      getByStoreIds(this.basicInfo.storeId).then(res => {
        if (res.data.success) {
          // "VPAY_ACCOUNT": "充值余额",
          // "VPAY_BONUS": "虚拟余额",
          // "VPAY_SETTLE": "结算余额"
          this.formLabelAlign.ACCT = res.data.data?.balances.ACCT?.balance
          this.formLabelAlign.BONUS = res.data.data?.balances.BONUS?.balance
        }
      }).finally(() => {
        let timer = setTimeout(() => {
          this.loading = false
          clearTimeout(timer)
        }, 500)
      })
    },
    // 获取收款账户列表
    async getBankList () {
      bankAccountGetAll().then(res => {
        this.bankList = res.data.data
      })
    },
    async getMsg () {
      if (!this.$route.query.id) {
        this.$router.push({ path: '/epay/vpayCharge' })
        return
      }
      await chargeGet(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.basicInfo = res.data.data
          this.inputAmount = this.basicInfo.amount
          if (this.basicInfo.tradeStatus !== 'APPLY' || this.basicInfo.tradeMethod === 'CHARGE_QRCODE') {
            this.hasAudited = true
          } else {
            this.hasAudited = false
          }
        } else {
          this.$router.push({ path: '/epay/vpayCharge' })
          return
        };
      })
    },
    changeAddress () {
      this.$refs.addressDialogRef.show('edit', this.basicInfo)
    },
    returnPage () {
      if (this.hasAudited) {
        if (window.history.length <= 1) {
          this.$router.push({ path: '/home' })
          return false
        } else {
          this.$router.go(-1)
        }
      } else {
        if (+this.inputAmount !== this.basicInfo.amount) {
          this.$message({ message: '充值金额有误', type: 'error' })
          return false
        }
        this.loadingPage = true
        chargeHandle({ action: 'audit', chargeId: this.basicInfo.orderId, amountBank: this.inputAmount }).then(res => {
          if (res.data.success) {
            this.$message({ message: '审核成功', type: 'success' })
            this.$router.go(-1)
            this.loadingPage = false
          }
        }).finally(() => {
          this.loadingPage = false
        })
      }
    },
    onReject () {
      this.IsReject = true
    },
    // 审核拒绝
    reject () {
      let str = this.remarks.replace(/\s*/g, '')
      if (!str) {
        this.$message({ message: '原因不能为空', type: 'error' })
        return false
      }
      this.loading = true
      chargeHandle({ action: 'reject', chargeId: this.basicInfo.orderId, remarks: this.remarks }).then(res => {
        if (res.data.success) {
          this.$message({ message: '审核已拒绝', type: 'success' })
          this.$router.go(-1)
          this.loading = false
          this.IsReject = false
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    getBankAccount () {
      let formData = this.bankList.filter(v => v.bankAccountId === this.basicInfo.bankAccountId)[0]
      console.log(formData)
      let bankAccountData = {}
      if (formData) {
        bankAccountData = {
          bankName: formData.bankName,
          cardNo: formData.cardNo
        }
      }
      return bankAccountData
    }
  }
}
</script>
<style scoped lang="less">
.recharge-details {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

.img {
  width: 50%;
  object-fit: cover;
  flex: 1;
}

@deep: ~">>>";
</style>
